import { LoadableAfterPaint } from '@confluence/loadable';
import type { SatisfactionSurveyComponentProps } from '../src/SatisfactionSurveyComponent.tsx';
export type { OnInteractionData } from '../src/SatisfactionSurveyComponent.tsx';

export const SatisfactionSurveyComponent = LoadableAfterPaint<SatisfactionSurveyComponentProps>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SatisfactionSurveyComponent" */ '../src/SatisfactionSurveyComponent.tsx'
			)
		).SatisfactionSurveyComponent,
});
